// extracted by mini-css-extract-plugin
export var childrenContainer = "_6q-0";
export var virtualScrollArea = "_6q-1";